<template>
  <v-dialog v-model="dialog" persistent max-width="1000">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Adicionar</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <br /><br />
        <v-form ref="form">
          <v-row>
            <v-col>
              <v-text-field
                label="Nome"
                name="solucaoTipoNome"
                :rules="[rules.required]"
                v-model="payload.solucaoTipoNome"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { tipoSolucaoAPI } from "../API/TipoSolucaoAPI";
import { mapActions, mapGetters } from "vuex";
import AppTemasCombobox from "./Combobox.vue";
import ComboGetProjetoByUf from "../../project/components/ComboGetProjetoByUf.vue";
import { VueEditor } from "vue2-editor";
export default {
  name: "AppModalInsert",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
  },
  components: {
    AppTemasCombobox,
    ComboGetProjetoByUf,
    VueEditor,
  },
  data() {
    return {
      payload: {},
      dialog: false,
      rules: {
        required: (value) => !!value || "Campo Obrigatório",
      },
      selectValidate: false,
    };
  },
  mounted() {
    if (this.object && this.edit === true) {
      this.payload = { ...this.object };
    }
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      if (this.$refs.form.validate()) {
        if (this.edit === true) {
          this.setLoading(true);
          tipoSolucaoAPI
            .update(this.payload)
            .then(() => {
              this.dialog = false;
              this.$emit("on-save");
              location.reload();
              this.setLoading(false);
            })
            .catch(() => {
              this.setLoading(false);
            });
        } else {
          this.setLoading(true);
          tipoSolucaoAPI
            .create(this.payload)
            .then(() => {
              this.dialog = false;
              this.$emit("on-save");
              location.reload();
              this.setLoading(false);
            })
            .catch(() => {
              this.setLoading(false);
            });
        }
      }
    },
  },
};
</script>
